<script setup lang="ts">
import {onMounted} from 'vue';
import CabHeader from '@/views/header/CabHeader.vue';
import CabLink from '@/views/header/CabLink.vue';
import {reload} from '@/base/loadingState.js';
import {RouterView} from 'vue-router';

onMounted(async () => {
    await reload();
});
</script>

<template>
  <div class="h-screen relative">
    <CabHeader>
      <CabLink name="Thema's" to="/admin/thema"/>
      <CabLink name="Instellingen" to="/admin/organization"/>
      <CabLink name="Gebruikers" to="/admin/user"/>
      <CabLink name="Mijlpalen" to="/admin/milestone" icon="m"/>
      <CabLink name="KPI's" to="/admin/kpi" icon="k"/>
      <CabLink name="Rapporten" to="/admin/status"/>
      <CabLink name="AltView" to="/admin/altview"/>
      <CabLink name="Vecozo" to="/admin/vecozo"/>
      <CabLink name="Dashboard" to="/admin/dashboard" :exact="false"/>
      <CabLink name="Beheer" to="/admin/admin"/>
    </CabHeader>

    <RouterView/>
  </div>
</template>
